/**
 * @param {ReduxState} state - The Redux state.
 * @param {string} seasonPid - The season id you want the leaderboard for
 * @returns {object} The Brownlow Tracker Leaderboard data state.
 */
export const leaderboardDataSelector = (state, seasonPid) =>
    state.brownlowTracker.leaderboard?.data?.[seasonPid] || null;
